import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({ message, onClose, dismissible = true, isGlobal = false }) => {
  if (!message) return null;

  return (
    <div className={`error-message ${isGlobal ? 'global-error' : ''}`}>
      <div className="error-content">
        <div className="error-icon">⚠️</div>
        <div className="error-text">{message}</div>
        {dismissible && (
          <button className="error-close-btn" onClick={onClose}>
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;